/**
 * Assigned Account Checkbox Component
 * Displays whether an account is assigned to the community
 */

import { Checkbox } from '@/core/components/ui/checkbox';

interface AssignedAccountCheckboxProps {
  isAssigned: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export function AssignedAccountCheckbox({
  isAssigned,
  disabled = true,
  onChange,
}: AssignedAccountCheckboxProps) {
  return (
    <Checkbox
      checked={isAssigned}
      disabled={disabled}
      onCheckedChange={(checked) => onChange?.(checked as boolean)}
      aria-label={isAssigned ? 'Assigned to community' : 'Not assigned to community'}
    />
  );
}
